import _ from "lodash";

/**
 * ICH's Invoice is the player's Options Report, printed from the invoice's Print Options. Cloud opens the job
 * read-only in the player (Status Detail) and asks the player for that dialog by setting this path in the
 * state it launches the player with. The player answers it once (ambifi-player-web
 * actions/invoicePrintRequestActions.js): the invoice opens on Print Options and, when the request carries
 * lines (an embedded Price List's unsaved ones), shows and prints those.
 */
export const INVOICE_PRINT_REQUEST_PLAYER_PATH = Object.freeze(["player", "invoicePrintRequest"]);
export const ICH_INVOICE_PRINT_REPORT_ID = "ich-options-report";

const isPlainObject = value => Boolean(value && _.isPlainObject(value));
const newRequestId = () => `invoice-print-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;

/**
 * @param {Object[]} [options.invoiceItems] The Price List's unsaved lines; omitted to print the saved job.
 * @param {string} [options.id] The request id (a new one by default).
 * @returns {{ id: string, reportId: string, invoiceItems?: Object[] }}
 */
export function buildInvoicePrintRequest({ invoiceItems, id = newRequestId() } = {}) {
	const request = { id, reportId: ICH_INVOICE_PRINT_REPORT_ID };
	if (invoiceItems !== undefined) {
		if (!Array.isArray(invoiceItems) || !invoiceItems.every(isPlainObject)) {
			throw new Error("The current Price List draft is incomplete. Reload it and try again.");
		}
		request.invoiceItems = _.cloneDeep(invoiceItems);
	}
	return request;
}

/**
 * The search hit the job is opened from for printing: the Status hit the Price List was launched from when
 * it matches the job, with the verified job's identity. Without one, the identity comes from the job and its
 * S3 key (<identityId>/<activityId>/<file>).
 *
 * @param {Object} launchSource appState.showPricing.source (kept only when it matches the job).
 * @param {Object} savedJob The verified session's job (appState.showPricing.checklist).
 * @param {string} url The verified session's S3 key.
 */
export function buildInvoicePrintHit(launchSource, savedJob, url) {
	const source = isPlainObject(launchSource) ? launchSource : {};
	const job = isPlainObject(savedJob) ? savedJob : {};
	const [identityId = "", activityId = ""] = _.toString(url).split("/");
	return {
		..._.cloneDeep(source),
		id: job.id || activityId || source.id || "",
		instanceId: job.instanceId || source.instanceId || "",
		identityId: identityId || source.identityId || "",
		url
	};
}
